import { jsx as _jsx } from "react/jsx-runtime";
import { HeatingCircuit } from 'z3k-config';
import { DragDropDrawer, Z3kDragDropContainer, } from 'z3k-settings/components/utils/drag-drop-drawer';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { unpack_validation } from 'z3k-parser/validation/types';
export function ClimaticHeatingCircuits() {
    const childrenItem = (selected_item_id) => {
        return (_jsx(DragDropDrawer, { z3k_name: "heating_circuits", name: RouteNaming[Z3kSecondRoutes.climatic_heating_circuit], item_url: Z3kSecondRoutes.climatic_heating_circuit, selected_item_id: selected_item_id, hideAddButton: true, hideTrashButton: true, objectFilter: (item) => item.type !== HeatingCircuit.Type.BOILER &&
                HeatingCircuit.isEnabled(item), is_climatic_hc: true }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
ClimaticHeatingCircuits.isWarning = () => false;
ClimaticHeatingCircuits.isError = (validation_result) => {
    return !!(unpack_validation(validation_result, 'heating_circuits') ||
        unpack_validation(validation_result, 'pumps') ||
        unpack_validation(validation_result, 'heating_modes') ||
        unpack_validation(validation_result, 'threeway_taps'));
};
ClimaticHeatingCircuits.isShown = (is_service_view, config, spec, is_staff, is_climatic) => {
    return is_climatic;
};
